"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonSlideTaskMatchPairs = void 0;
var enums_1 = require("./enums");
var utils_lesson_slide_1 = require("./utils-lesson-slide");
/**
 * Cлайд задания Сопоставить пары
 */
var LessonSlideTaskMatchPairs = /** @class */function () {
  function LessonSlideTaskMatchPairs() {
    this.type = enums_1.LessonSlideContentTypeEnum.TaskMatchPairs;
    /** Количество колонок */
    this.columns = 2;
    /** Количество строк */
    this.rows = 1;
    /** Множитель высоты области ответов */
    this.height_ratio = 1;
    this.aspect_ratio = enums_1.LessonSlideImageAspectRatioEnum.square;
  }
  /**
   * Возвращает конфигурацию области просмотра исходя из возможностей устройства
   */
  LessonSlideTaskMatchPairs.configureViewport = function (slide, baseWidth, baseHeight, cellOffset) {
    if (baseWidth === void 0) {
      baseWidth = 360;
    }
    if (baseHeight === void 0) {
      baseHeight = 250;
    }
    if (cellOffset === void 0) {
      cellOffset = 10;
    }
    return utils_lesson_slide_1.UtilsLessonSlide.configureViewport(baseWidth, baseHeight, cellOffset, slide);
  };
  return LessonSlideTaskMatchPairs;
}();
exports.LessonSlideTaskMatchPairs = LessonSlideTaskMatchPairs;
